// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1RrBA","notes":"Notes_notes__3-vzI","note":"Notes_note__1DeF-","markdown":"Notes_markdown__2E_Yu"};